import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  getListTenantDivisionsQueryKey,
  type UpdateTenantDivisionMutationError,
  useUpdateTenantDivision,
} from '@/entities/tenants-divisions/api/generated/api';
import { toast } from '@/shared/ui';

export const useOrganizationsEditMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useUpdateTenantDivision({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(
          t('common.messages.update-success', {
            name: t('master-management.menu.organizations'),
          }),
        );
        queryClient.invalidateQueries({
          queryKey: getListTenantDivisionsQueryKey(),
        });
        onSuccess();
      },
      onError: (error: UpdateTenantDivisionMutationError) => {
        if (error.response?.data.error_code === 'VALIDATION_ERROR') {
          toast.error(t('master-management.organizations.create.error.duplicate-code'));
          return;
        }
        toast.error(
          t('common.messages.update-failed', {
            name: t('master-management.menu.organizations'),
          }),
        );
      },
    },
  });
};
